import { SchedulerCacheService } from "../scheduler/cache";
import { FreeSlotsCacheService } from "./cache";

export const FreeSlotsMutationHandler = {
  daySlotsBucketsCreated({ buckets }) {
    SchedulerCacheService.replaceBuckets(buckets);
    FreeSlotsCacheService.invalidateAll();
  },
};
